/**
 * External dependencies
 */
import { usePage } from '@inertiajs/react';
import { createContext, useContext, useEffect, useState } from 'react';

const PropertyLocationContext = createContext({});

export const PropertyLocationContextProvider = ({ children }) => {
    const [geoCordinates, setGeoCordinates] = useState(null);
    const { coordinates } = usePage().props;

    useEffect(() => {
        updateMapToUserLocation();
    }, []);

    const handleGeoCordinatesChange = (property) => {
        setGeoCordinates({
            lat: property.lat,
            lng: property.lng,
        });
    };

    const updateMapToUserLocation = () => {
        if (coordinates?.latitude && coordinates?.longitude) {
            setGeoCordinates({
                lat: coordinates?.latitude,
                lng: coordinates?.longitude,
            });
        }
    };

    const providerData = {
        handleGeoCordinatesChange,
        updateMapToUserLocation,
        geoCordinates,
        setGeoCordinates,
    };

    return <PropertyLocationContext.Provider value={providerData}>{children}</PropertyLocationContext.Provider>;
};

export const usePropertyLocationContext = () => {
    return useContext(PropertyLocationContext);
};
